export default __webpack_public_path__ + "static/media/SWT1190.34I-37378_-22054_0.91afa937.jpg";